export const Skeleton = () => (
  <div className="w-full h-full rounded-[inherit] bg-neutral-200 relative after:content-[''] after:bg-white/70 after:animate-pulse after:rounded-[inherit] after:absolute after:inset-0" />
);
